/** Use this function to jump to another page when you are outside React Router */
export const goToRoute = (page: string) => {
  window.location.href = `${import.meta.env.VITE_APP_FRONT_URL_PREFIX ?? ""}${page}`;
};
